import {EuiComboBox, EuiDescribedFormGroup, EuiFieldText, EuiFormRow, EuiLink,} from "@elastic/eui";
import {useField, useFormikContext} from "formik";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Contact, ContactFormValues} from "../../../app/models/contact";
import {Store} from "../../../app/stores/store-root";

type BeneficiaryProps = {
    readonly?: boolean
}
export const Beneficiary = ({readonly}: BeneficiaryProps) => {
    const [selectedOptions, setSelected] = useState<any[]>([]);
    const [isLoading, setLoading] = useState(false);
    const [options, setOptions] = useState<any>([]);
    const [beneficiary, setBeneficiary] = useState<Contact | undefined>(
        undefined
    );
    const store = useContext(Store);
    const formik = useFormikContext();
    const onSearchChange = (searchValue: string) => {
        if (searchValue) {
            setLoading(true);
            setOptions([]);
            store.Contacts.LoadItems(searchValue)
                .then(() => {
                    setOptions(store.Contacts.ItemsAsListOptions);
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("Errors");
                }).finally(() => {
                setLoading(false);
            });
        }

    };

    const onBeneficiaryChange = (selectedOptions: any) => {

        if (!selectedOptions || selectedOptions.length === 0) {
            setBeneficiary(undefined);
            setSelected([]);
            return;
        }
        setSelected(selectedOptions);
        store.Contacts.LoadContact(selectedOptions[0].key).then((contact) => {
            console.log('found contact ', contact);
            if (contact) {
                setBeneficiary(contact);
                formik.getFieldHelpers('BeneficiaryName').setValue(contact.Name);
                //formik.getFieldHelpers('BeneficiaryEmail').setValue(contact.Email);
                formik.getFieldHelpers('BeneficiaryPhone').setValue(contact.Phone);

            }
        })
    };

    const onCreateOption = (searchValue: any) => {
        console.log("creating a new user");
        setBeneficiary(new ContactFormValues());
        formik.getFieldHelpers('BeneficiaryName').setValue(undefined);
        //formik.getFieldHelpers('BeneficiaryEmail').setValue(undefined);
        formik.getFieldHelpers('BeneficiaryPhone').setValue(undefined);
    };

    //initialize fields
    useEffect(() => {
        if (formik.getFieldProps('RemitterPhone').value) {
            store.Contacts.LoadContact(formik.getFieldProps('BeneficiaryPhone').value).then((contact) => {
                setBeneficiary(contact);
                setSelected([{
                    key: formik.getFieldProps('BeneficiaryPhone').value,
                    value: formik.getFieldProps('BeneficiaryPhone').value,
                    label: formik.getFieldProps('BeneficiaryName').value
                }])
            })
        }
    }, []);


    return (
        <Fragment>
            <EuiDescribedFormGroup
                title={<h3>Beneficiary</h3>}
                description={
                    <Fragment>
                        Search remitter by their phone number. If new entry Please enter  <b>first name</b> , <b>middle name</b>  and <b>surname</b> ! all in <b>New beneficiary name</b> box . Please spell correctly to avoid mismatches at the receiving end.
                    </Fragment>
                }
            >
                <EuiFormRow
                    label="Existing beneficiary phone number"
                    isInvalid={(formik.getFieldMeta('BeneficiaryName').error && formik.getFieldMeta('BeneficiaryName').touched) ? true : false}
                    error={formik.getFieldMeta('BeneficiaryName').error}
                >
                    <EuiComboBox
                        placeholder="Use beneficiary phone, email or name "
                        async
                        options={options}
                        selectedOptions={selectedOptions}
                        isLoading={isLoading}
                        onChange={onBeneficiaryChange}
                        onSearchChange={onSearchChange}
                        singleSelection={{asPlainText: true}}
                        onCreateOption={onCreateOption}
                        isInvalid={(formik.getFieldMeta('BeneficiaryName').error && formik.getFieldMeta('BeneficiaryName').touched) ? true : false}
                        customOptionText="Add {searchValue} as your a new beneficiary"
                        isDisabled={readonly}
                        data-test-subj={'beneficiary-field'}
                    />
                </EuiFormRow>
                {beneficiary ? (
                    <Fragment>
                        <EuiFormRow label="New beneficiary name"
                                    isInvalid={(formik.getFieldMeta('BeneficiaryName').error && formik.getFieldMeta('BeneficiaryName').touched) ? true : false}
                                    error={formik.getFieldMeta('BeneficiaryName').error}>
                            <EuiFieldText
                                placeholder="Beneficiary name"
                                data-test-subj={'beneficiary-name'}
                                isInvalid={(formik.getFieldMeta('BeneficiaryName').error && formik.getFieldMeta('BeneficiaryName').touched) ? true : false}
                                disabled={readonly}
                                {...formik.getFieldProps('BeneficiaryName')}
                            /></EuiFormRow>
                        {/*<EuiFormRow label="Beneficiary email"
                                    isInvalid={(formik.getFieldMeta('BeneficiaryEmail').error && formik.getFieldMeta('BeneficiaryEmail').touched) ? true : false}
                                    error={formik.getFieldMeta('BeneficiaryEmail').error}>
                            <EuiFieldText
                                placeholder="Beneficiary email"
                                disabled={readonly}
                                isInvalid={(formik.getFieldMeta('BeneficiaryEmail').error && formik.getFieldMeta('BeneficiaryEmail').touched) ? true : false}
                                {...formik.getFieldProps('BeneficiaryEmail')}
                            /></EuiFormRow>*/}
                        <EuiFormRow label="Beneficiart phone"
                                    isInvalid={(formik.getFieldMeta('BeneficiaryPhone').error && formik.getFieldMeta('BeneficiaryPhone').touched) ? true : false}
                                    error={formik.getFieldMeta('BeneficiaryPhone').error}>
                            <EuiFieldText
                                placeholder="Beneficiary phone"
                                data-test-subj={'beneficiary-phone'}
                                disabled={readonly}
                                isInvalid={(formik.getFieldMeta('BeneficiaryPhone').error && formik.getFieldMeta('BeneficiaryPhone').touched) ? true : false}
                                {...formik.getFieldProps('BeneficiaryPhone')}
                            /></EuiFormRow>
                    </Fragment>
                ) : (
                    ""
                )}
            </EuiDescribedFormGroup>
        </Fragment>
    );
};
